import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../environments/environment';

@Injectable()
export class HomeService {

  constructor(
    public http: HttpClient,
  ) {
  }

  async fetchHomeData() {
    const url = environment.baseApiUrl + 'home';

    try {
      const home: any = await this.http.get(url).toPromise();
      return home.data;
    } catch (error) {
      console.log('ERROR:', error);
    }
  }
}
